import { Injectable } from '@angular/core';
import { IAdapter } from 'src/app/lego-utils';
import { BOMItem } from 'src/app/models/domain';
import { IBomItemMaterial } from 'src/app/state/bom-item-material.model';
import {
  YPLMBOMSRVBomItem,
  YPLMBOMSRVBomItemCreate,
  YPLMBOMSRVBomItemUpdate,
} from 'src/generated-clients/bom';

@Injectable({
  providedIn: 'root',
})
export class BOMItemAdapter implements IAdapter<
  BOMItem,
  IBomItemMaterial,
  YPLMBOMSRVBomItemUpdate
> {
  public get $select() {
    const propertyNames: Array<keyof YPLMBOMSRVBomItem> = [
      'Item',
      'ItemCategory',
      'ItemMaterial',
      'Quantity',
      'Unit',
      'SortSequence',
    ];

    return [...propertyNames];
  }

  public adaptToDTO(bomItem: Partial<BOMItem>): Partial<YPLMBOMSRVBomItemUpdate> {
    return {
      ItemCategory: bomItem.itemCategory,
      ItemMaterial: bomItem.component,
      // test environment for creating an eco number: https://dkatest-eco.corp.lego.com/eco/lego_view.act
      NextChangeNumber: bomItem.engineeringChangeOrderNumber,
      Quantity: bomItem.weight,
      SortSequence: bomItem.sortString,
      Unit: bomItem.unit,
    };
  }

  public adaptToCreateDTO(designId: string, bomItem: Partial<BOMItem>): YPLMBOMSRVBomItemCreate {
    return {
      Alternative: '1',
      HeaderMaterial: designId,
      // the API ignores this but it's required
      Item: '',
      ItemCategory: bomItem.itemCategory,
      ItemMaterial: bomItem.component,
      NextChangeNumber: bomItem.engineeringChangeOrderNumber,
      Plant: '500',
      Quantity: bomItem.weight,
      SortSequence: bomItem.sortString,
      Unit: bomItem.unit,
      Usage: 'M',
    };
  }

  public adaptToDomain(item: IBomItemMaterial): BOMItem {
    return new BOMItem(
      item.item,
      '',
      item.itemCategory,
      item.itemMaterial,
      item.quantity,
      item.unit,
      item.sortSequence,
      undefined
    );
  }
}
